<div class="disclaimer">
  <span class="disclaimer__badge" *ngIf="badge">
    {{ badge }}
  </span>
  <mat-icon class="disclaimer__icon" [svgIcon]="icon">{{ icon }}</mat-icon>
  <span class="disclaimer__text" [innerHTML]="message"></span>
</div>
